// Emilia's pages — one list for the sidebar, the dashboard routes, the shared
// view and the server's access check. Each page is shared on its own, by user
// group like a shutter on /control: settings.emiliaConfig.pages[id].accessGroups.
// Empty or missing = not shared. Shared pages are read-only and live in their own
// view (/shared), not in /control — there is nothing to control on them.
export const EMILIA_PAGES = [
  { id: 'termine',  label: 'Termine',  icon: 'event',    empty: 'Noch keine Termine.' },
  { id: 'kontakte', label: 'Kontakte', icon: 'contacts', empty: 'Noch keine Kontakte.' },
]

export const EMILIA_PAGE_IDS = EMILIA_PAGES.map(p => p.id)

// A Termin is either something to go to or a day the KiTa/school is closed
export const TERMIN_KINDS = ['termin', 'schliesstag']

// Deep links: the dashboard page and the shared read-only view
export const emiliaPath       = (id) => (id ? `/emilia/${id}` : '/emilia')
export const emiliaSharedPath = (id) => (id ? `/shared/emilia/${id}` : '/shared')

/** Ids of the Emilia pages shared with any of `userGroups`, in page order. */
export function emiliaPagesFor(emiliaConfig, userGroups = []) {
  return EMILIA_PAGE_IDS.filter(id => {
    const ag = emiliaConfig?.pages?.[id]?.accessGroups ?? []
    return ag.some(g => userGroups.includes(g))
  })
}
